import { getGradeReportbyCourse } from "./courses";

export function computeFinalGrade(gradeitems) {
  if (!Array.isArray(gradeitems) || gradeitems.length === 0) return null;

  const { activityItems, gradedItems } = splitActivityItems(gradeitems);
  if (activityItems.length === 0 || gradedItems.length === 0) return null;

  const isCompleted = gradedItems.length === activityItems.length;
  const courseTotalItem = gradeitems.find(
    (item) => item.itemtype === "course" && !item.gradeishidden
  );

  let raw = null;
  let formatted = "-";

  if (courseTotalItem) {
    if (courseTotalItem.graderaw !== null && courseTotalItem.graderaw !== undefined) {
      raw = Number(courseTotalItem.graderaw);
    }
    formatted = formatCourseGrade(courseTotalItem, raw);
  }

  if (formatted === "-" || formatted === null) {
    const sum = gradedItems.reduce((acc, item) => acc + Number(item.graderaw), 0);
    const average = sum / gradedItems.length;
    raw = average;
    formatted = formatGrade(average);
  }

  return { raw, formatted, isCompleted };
}

export function computeCourseProgress(gradeitems) {
  const { activityItems, gradedItems } = splitActivityItems(gradeitems);
  if (activityItems.length === 0) return null;

  return (gradedItems.length * 100) / activityItems.length;
}

export function splitActivityItems(gradeitems) {
  if (!Array.isArray(gradeitems)) return { activityItems: [], gradedItems: [] };

  const activityItems = gradeitems.filter(
    (d) =>
      d.itemtype !== "course" &&
      d.itemtype !== "category" &&
      d.itemmodule !== "folder" &&
      d.itemname !== null &&
      d.itemname !== ""
  );
  const gradedItems = activityItems.filter(
    (item) =>
      !item.gradeishidden &&
      item.graderaw !== null &&
      item.graderaw !== undefined
  );

  return { activityItems, gradedItems };
}

export function formatCourseGrade(courseItem, fallbackRaw) {
  if (courseItem?.gradeformatted && courseItem.gradeformatted.trim() !== "-") {
    const trimmed = courseItem.gradeformatted.trim();
    if (trimmed.includes("(")) {
      return trimmed.split("(")[0].trim();
    }
    return trimmed;
  }

  if (fallbackRaw !== null && fallbackRaw !== undefined && !isNaN(fallbackRaw)) {
    return formatGrade(fallbackRaw);
  }

  return "-";
}

export function formatGrade(value) {
  const rounded = Number(`${Math.round(Number(`${value}e1`))}e-1`);
  return rounded.toFixed(1).replace(".", ",");
}

export async function resolveCourseGradeAndProgress({
  token,
  id,
  courseId,
  course_id,
  baseUrl,
}) {
  try {
    const data = await getGradeReportbyCourse({
      token,
      id,
      course_id: courseId ?? course_id,
      ...(baseUrl ? { baseUrl } : {}),
    });
    const gradeitems = data?.usergrades?.[0]?.gradeitems;
    return {
      finalGrade: computeFinalGrade(gradeitems),
      progress: computeCourseProgress(gradeitems),
    };
  } catch {
    return { finalGrade: null, progress: null };
  }
}
